<template>
  <el-dialog :append-to-body="true" :visible.sync="value" title="审批同意前，请确认佣金及优惠返佣金额是否正确！" center :show-close="false" width="480px" custom-class="approve-edit-con" :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed">
    <a class="close-con" @click="closed">
      <i class="iconfont iconshanchu"></i>
    </a>
    <el-form :model="handleInfo" :rules="subscribeRules" class="modify-con" ref="modifyCon">
      <div class="item">
        <span class="label">佣金（元）：</span>
        <el-form-item prop="brokerage" class="lebel-con" v-if="is_allow_edit">
          <el-input v-model="handleInfo.brokerage" placeholder="请输入佣金（元）"></el-input>
        </el-form-item>
        <p v-comma:{fixed:2}="handleInfo.brokerage" v-else></p>
      </div>
      <div class="item">
        <span class="label">优惠返佣（元）：</span>
        <el-form-item prop="discount_amount" class="lebel-con" v-if="is_allow_edit">
          <el-input v-model="handleInfo.discount_amount" placeholder="请输入优惠返佣（元）"></el-input>
        </el-form-item>
        <p v-comma:{fixed:2}="handleInfo.discount_amount" v-else></p>
      </div>
      <div class="item custom-btn menu-list">
        <span class="label"></span>
        <el-button type="primary" @click="passEvent">通过</el-button>
        <el-button type="info" @click="closed">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import {validateMoney} from '@/utils/validate';
export default {
  name: 'ApprovePassModal',
  props: {
    value: Boolean,
    is_allow_edit: Boolean,
    info: Object
  },
  data () {
    return {
      handleInfo: {
        brokerage: '',
        discount_amount: ''
      },
      subscribeRules: {
        brokerage: [
          {validator: validateMoney, name: '佣金', isEmpty: false, trigger: 'blur'}
        ],
        discount_amount: [
          {validator: validateMoney, name: '优惠返佣', isEmpty: false, trigger: 'blur'}
        ]
      },
    }
  },
  watch: {
    value (val) {
      if (val) {
        if (this.info && Object.keys(this.info).length > 0) {
          this.handleInfo = {...this.info};
        }
      }
    }
  },
  mounted () {
    if (this.info && Object.keys(this.info).length > 0) {
      this.handleInfo = {...this.info};
    }
  },
  methods: {
    closed () {
      this.handleInfo= {
        brokerage: '',
        discount_amount: ''
      };
      this.$refs.modifyCon && this.$refs.modifyCon.clearValidate();
      this.$emit('input', false);
    },
    passEvent () {
      this.$refs.modifyCon && this.$refs.modifyCon.validate(async valid => {
        if (!valid) return null;
        this.$emit('confirm', {...this.handleInfo});
      })
    }
  }
}
</script>